var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBendSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.782,
    height: 126.935,
    viewBox: "0 0 97.782 126.935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#39a32e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-914 -511)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(914 511)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M71.349,43.188C68.922,45.183,50.9,55.109,50.9,55.109l-16.91,7.745L25.456,43.188s21.983-19.112,24.863-20.6c1.165-.605,10.82-5.4,15.572-7.765a3.727,3.727,0,0,1,4.532.947C74.113,20.2,81.871,29.981,81.95,33.846Z",
    transform: "translate(-3.382 -2.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M47.554,45.993,31.8,80.292,21.727,111.714a3.464,3.464,0,0,1-3.938,2.6,3.83,3.83,0,0,1-2.523-4.752l8.481-33.143,13.015-47.3.443-1.238Z",
    transform: "translate(-15.131 12.339)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M39.306,36.524",
    transform: "translate(12.377 22.173)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.891,34.524l6.9,39.233-.77,32.794a3.389,3.389,0,0,0,2.89,3.677,3.9,3.9,0,0,0,3.964-3.694l2.854-33.919,2.414-39.6-.015-1.306Z",
    transform: "translate(0.526 16.697)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.285,35.97c-.015,0-.015,0-.009-.019a2.2,2.2,0,0,1,.162-1.067c.073-.173,14.082-23.14,14.082-23.14a1.574,1.574,0,0,1,1.15-.115l20.057,4.765a5.321,5.321,0,0,1,3.316,2.446L65.458,24.2c-5.5-1.518-15.512-4.9-18.8-6.048a1.629,1.629,0,0,0-1.764.453L32.982,36.693a2.5,2.5,0,0,1-3.416.6,2.5,2.5,0,0,1-1.281-1.325",
    transform: "translate(-0.185 -6.221)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M74.433,58.091c0,.017,0,.017-.019.013a2.218,2.218,0,0,1-1.08.021c-.182-.043-25.194-9.949-25.194-9.949a1.584,1.584,0,0,1-.31-1.114L48.555,27.4l7.968-3.94c-.562,5.676-2.2,16.121-2.766,19.557a1.624,1.624,0,0,0,.746,1.659l19.845,8.669a2.869,2.869,0,0,1,.086,4.75",
    transform: "translate(22.067 7.304)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 12.009,
    cy: 12.009,
    rx: 12.009,
    ry: 12.009,
    transform: "translate(72.436 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBendSelected);
export default __webpack_public_path__ + "static/media/BendSelected.bcd960040995fcd8ba102f6efb25ec6e.svg";
export { ForwardRef as ReactComponent };